import React from 'react';
import { QuickActionButton } from '.';

export default function QuickActionsEditStartDate({ render = true, onClick }) {
  return <QuickActionButton render={render} onClick={onClick} text={'Edit start date'} />;
}
